export default [
  {
    name: 'Midway Island, Samoa',
    value: 'US/Samoa',
  },
  {
    name: 'Hawaii',
    value: 'US/Hawaii',
  },
  {
    name: 'Gambier Islands',
    value: 'Pacific/Gambier',
  },
  {
    name: 'Alaska',
    value: 'US/Alaska',
  },
  {
    name: 'Pacific Time (US & Canada)',
    value: 'US/Pacific',
  },
  {
    name: 'Mountain Time (US & Canada)',
    value: 'US/Mountain',
  },
  {
    name: 'Central Time (US & Canada), Mexico City',
    value: 'US/Central',
  },
  {
    name: 'Eastern Time (US & Canada), Bogota, Lima',
    value: 'US/Eastern',
  },
  {
    name: 'Atlantic Time (Canada), Caracas, La Paz',
    value: 'Canada/Atlantic',
  },
  {
    name: 'Newfoundland',
    value: 'Canada/Newfoundland',
  },
  {
    name: 'South Georgia',
    value: 'Atlantic/South_Georgia',
  },
  {
    name: 'Cape Verde',
    value: 'Atlantic/Cape_Verde',
  },
  {
    name: 'Azores',
    value: 'Atlantic/Azores',
  },
  {
    name: 'Western Europe Time, London, Lisbon, Casablanca',
    value: 'Europe/London',
  },
  {
    name: 'Brussels, Copenhagen, Madrid, Paris',
    value: 'Europe/Brussels',
  },
  {
    name: 'Vilnius, Kiev, Riga, Sofia, Tallinn, Helsinki',
    value: 'Europe/Kiev',
  },
  {
    name: 'Baghdad, Riyadh, Moscow, St. Petersburg',
    value: 'Asia/Baghdad',
  },
  {
    name: 'Abu Dhabi, Muscat, Baku, Tbilisi',
    value: 'Asia/Tbilisi',
  },
  {
    name: 'Tehran',
    value: 'Asia/Tehran',
  },
  {
    name: 'Ekaterinburg, Islamabad, Karachi, Tashkent',
    value: 'Asia/Yekaterinburg',
  },
  {
    name: 'Bombay, Calcutta, Madras, New Delhi',
    value: 'Asia/Calcutta',
  },
  {
    name: 'Kathmandu',
    value: 'Asia/Kathmandu',
  },
  {
    name: 'Almaty, Dhaka, Colombo',
    value: 'Asia/Dhaka',
  },
  {
    name: 'Bangkok, Hanoi, Jakarta',
    value: 'Asia/Bangkok',
  },
  {
    name: 'Beijing, Perth, Singapore, Hong Kong',
    value: 'Asia/Singapore',
  },
  {
    name: 'Tokyo, Seoul, Osaka, Sapporo, Yakutsk',
    value: 'Asia/Tokyo',
  },
  {
    name: 'Adelaide, Darwin',
    value: 'Australia/Darwin',
  },
  {
    name: 'Eastern Australia, Guam',
    value: 'Australia/Melbourne',
  },
  {
    name: 'Magadan, Solomon Islands, New Caledonia',
    value: 'Asia/Magadan',
  },
  {
    name: 'Auckland, Wellington, Fiji, Kamchatka',
    value: 'Pacific/Fiji',
  },
]
